export default __webpack_public_path__ + "static/media/nabh-website.b0754a5f.png";